import { TENANT_AT, TENANT_CH } from 'shared/consts'
import { CUSTOMER_REDIRECT } from 'shared/experiments/consts'
import { isExperimentEnabled } from 'shared/experiments/utils/experiments'
import { bindTrackingEvents } from 'shared/experiments/utils/tracking'

import {
  EVENT_AT_REDIRECTION,
  EVENT_CH_REDIRECTION,
  EVENT_NO_REDIRECTION,
} from './consts'
import CustomerRedirectionModal from './CustomerRedirectionModal'

/**
 * Note, that `EVENT_TRIGGERED` is triggered within `CustomerRedirectionModal` itself
 */
const registerEvents = () => {
  const parentElementAt =
    CustomerRedirectionModal.getTenantSpecificSelector(TENANT_AT)
  const parentElementCh =
    CustomerRedirectionModal.getTenantSpecificSelector(TENANT_CH)

  bindTrackingEvents([
    // Close X icon + DE button
    {
      selector: `[data-clientside-hook~="CustomerRedirectionModalCloser"]`,
      event: 'click',
      trackingEvent: EVENT_NO_REDIRECTION,
    },
    // For each tenant: Flag + link in the text
    {
      selector: `${parentElementAt} a, a${parentElementAt}`,
      event: 'click',
      trackingEvent: EVENT_AT_REDIRECTION,
    },
    {
      selector: `${parentElementCh} a, a${parentElementCh}`,
      event: 'click',
      trackingEvent: EVENT_CH_REDIRECTION,
    },
  ])
}

export default () => {
  if (isExperimentEnabled(CUSTOMER_REDIRECT)) {
    registerEvents()
  }
}
